<script setup>
import { tv } from 'tailwind-variants';
import { useTabsContext } from './useTabs';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);
const tabItemThemes = tv({
  base: 'flex items-center font-medium text-brand-text cursor-pointer hover:bg-brand-black-alpha-5 hover:dark:bg-brand-white-alpha-5 py-1.5 px-3 rounded-lg text-xs',
  variants: {
    active: {
      true: 'bg-brand-black-alpha-7 dark:bg-brand-white-alpha-7',
    },
  },
});
const { rootValue, onChange } = useTabsContext();

function onClick() {
  emit('click');
  onChange(props.value);
}
</script>

<template>
  <button
    :class="tabItemThemes({ active: rootValue === props.value })"
    data-component="CsTabItem"
    @click="onClick"
  >
    <slot />
  </button>
</template>
